import(/* webpackMode: "eager" */ "/vercel/path0/app/ressurser/kalorikalkulator/page.tsx");
